<mat-selection-list
  *ngIf="!!bundles"
  aria-label="Bundles"
  [color]="color"
  [ngModel]="selected"
  [compareWith]="_compareWithBundles"
  (selectionChange)="handleSelectionChange($event)"
>
  <mat-list-option
    *ngFor="let bundle of bundles"
    [value]="bundle"
    [attr.aria-labelledby]="'rds-bundle-label-' + bundle.id"
    [attr.aria-describedby]="'rds-bundle-description-' + bundle.id"
  >
    <h3 matLine [attr.id]="'rds-bundle-label-' + bundle.id">{{ bundle.name }}</h3>
    <p *ngIf="bundle.description as desc" matLine [attr.id]="'rds-bundle-description-' + bundle.id">{{ desc }}</p>
    <p [attr.id]="'rds-included-formats-' + bundle.id" matLine class="rds-c-format-chips">Included formats</p>
    <ul [attr.aria-labelledby]="'rds-included-formats-' + bundle.id" fxLayout="row wrap">
      <li *ngFor="let format of bundle.includedFormats" class="dense rds-c-chip">
        {{ format.name }}
      </li>
    </ul>
  </mat-list-option>
</mat-selection-list>
